import Slider, { Settings } from 'react-slick'

import style from './HowWork.module.scss'
import { HowWorkCard } from './HowWorkCard'
import { howWorkMock } from './howWorkMock'

const settings: Settings = {
  dots: true,
  infinite: true,
  arrows: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  focusOnSelect: false,
  dotsClass: style.dots,
}

// мобильный слайдер блока "как это работает?"
export function HowWorkMobileSlider() {
  return (
    <Slider {...settings}>
      {howWorkMock.map(item => (
        <HowWorkCard {...item} pic={item.picMob} key={item.num} />
      ))}
    </Slider>
  )
}
